var _excluded = ["title", "stroke", "dir"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgStarFilled = function SvgStarFilled(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Filled Star' : _ref$title,
    stroke = _ref.stroke,
    dir = _ref.dir,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 46 44"
  }, dir === 'rtl' ? {
    transform: 'scale(-1, 1)'
  } : {}), /*#__PURE__*/React.createElement("path", {
    stroke: stroke,
    strokeWidth: 3,
    d: "M23 36.5L8.893 43.916l2.694-15.708L.175 17.084l15.772-2.292L23 .5l7.053 14.292 15.772 2.292-11.412 11.124 2.694 15.708z",
    fillRule: "evenodd"
  }));
};
SvgStarFilled = pure(SvgStarFilled);
SvgStarFilled.displayName = 'SvgStarFilled';
export default SvgStarFilled;